/**
 * 判断是否微信
 */
export function isWeiXin(){
    var ua = window.navigator.userAgent.toLowerCase();
    if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        return true;
    }else{
        return false;
    }
}
/**
 * 截取参数
 */
export function scene_decode(e) {
    if (e === undefined)
        return {};
    let scene = decodeURIComponent(e),
        params = scene.split('&'),
        data = {};
    for (let i in params) {
        var val = params[i].split('=');
        val.length > 0 && val[0] && (data[val[0]] = val[1] || null)
    }
    return data;
}

/**
 * 获取cookie
 */
export function getCookie (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) != -1) {
        return c.substring(name.length, c.length);
        }
    }
    return "";
}

/**
 * 禁用微信分享
 */
export function disableWxShare(){
    function onBridgeReady () {
        window.WeixinJSBridge.call('hideOptionMenu')
    }
    if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
        } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
        }
    } else {
        onBridgeReady()
    }
}
